import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAirSeparator = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 65.5,
	height: 106,
	viewBox: "0 0 65.5 106.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 28,
		y: 0,
		width: 10,
		height: 106,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 53.0 23.0 L 61.5 23.0 M 61.5 13.0 L 61.5 33.0 M 65.5 13.0 L 65.5 33.0 M 13.0 83.0 L 4.5 83.0 M 4.5 73.0 L 4.5 93.0 M 0.0 73.0 L 0.0 93.0 M 53.0 13.0 L 53.0 93.0 A 13.0 5.0 0.0 0 1 13.0 93.0 L 13.0 13.0 A 13.0 5.0 0.0 0 1 53.0 13.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgAirSeparator;
